const { createFrame } = require('./iframe')
const { getToken, isTokenExpired } = require('./token')

let iframe = null
let loading = null
let url = ''
let mock = false
let token = ''

export function configureConnector({ connectorUrl, frameId, mockMode, mockToken }) {
  if (mockMode) {
    mock = true
    token = mockToken
  } else if (iframe) {
    console.warn('tc-accounts connector can only be configured once, this request has been ignored.')
  } else {
    iframe = createFrame(frameId, connectorUrl)
    url = connectorUrl

    loading = new Promise((resolve) => {
      iframe.onload = function () {
        loading = null
        resolve()
      }
    })
  }
}

const proxyCall = function () {
  if (mock) {
    throw new Error('connector is running in mock mode. This method (proxyCall) should not be invoked.')
  }

  if (!iframe) {
    throw new Error('connector has not yet been configured.')
  }

  function request() {
    const token = getToken('v3jwt')
    // 65 is offset in seconds, before expiry
    if (token && !isTokenExpired(token, 65)) {
      return new Promise((resolve, reject) => {
        token ? resolve({ token: token }) : reject("v3jwt cookie not found")
      })
    } else {
      return new Promise((resolve, reject) => {
        function receiveMessage(e) {
          const safeFormat = e.data.type === "SUCCESS" || e.data.type === "FAILURE"
          if (safeFormat) {
            window.removeEventListener('message', receiveMessage)
            if (e.data.type === "SUCCESS") {
              getToken('v3jwt') ? resolve({ token: getToken('v3jwt') }) : reject("v3jwt cookie not found")
            } else {
              reject("unable to get refesh token")
            }
          }
        }

        window.addEventListener('message', receiveMessage)

        const payload = { type: "REFRESH_TOKEN" }

        iframe.contentWindow.postMessage(payload, url)
      })
    }
  }

  if (loading) {
    return loading = loading.then(request)
  } else {
    return request()
  }
}

export function getFreshToken() {
  if (mock) {
    if (token) {
      return Promise.resolve(token)
    } else {
      return Promise.reject('connector is running in mock mode, but no token has been specified.')
    }
  }

  return proxyCall()
    .then(data => data.token)
}



